import { render, staticRenderFns } from "./ResultTitle.vue?vue&type=template&id=e054c446&scoped=true"
import script from "./ResultTitle.vue?vue&type=script&lang=js"
export * from "./ResultTitle.vue?vue&type=script&lang=js"
import style0 from "./ResultTitle.vue?vue&type=style&index=0&id=e054c446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e054c446",
  null
  
)

export default component.exports